/* 倒入 api */
import axios from '@/utils/ajax/index';

/* 导出文件 api */
import fileExport from '@/utils/fileExport/index';


/* 获取药品统计列表 */
export const statsDrugs = (data) => {
  return axios({
    url: '/statistic/statistics/drug',
    method: 'post',
    data,
  });
};

/* 获取药品统计列表 */
export const listRealTimeStatisticDrug = (data) => {
  return axios({
    url: '/statistic/drug/listRealTimeStatisticDrug',
    method: 'post',
    data,
  });
};

/* 获取诊所下的医生列表 */
export const getDoctors = (params) => {
  return axios({
    url: '/hospitalManage/doctor/listDoctorName',
    method: 'get',
    params,
  });
};

/* 获取流水统计 */
export const getStream = (data) => {
  return axios({
    url: '/statistic/finance/stream',
    method: 'post',
    data,
  });
};

/* 获取流水明细列表 */
export const listDetailed = (data) => {
  return axios({
    url: '/statistic/finance/listDetailed',
    method: 'post',
    data,
  });
};

/* 订单统计 */
export const order = (data) => {
  return axios({
    url: '/statistic/order/order',
    method: 'post',
    data,
  });
};

/* 订单利润统计 */
export const profit = (data) => {
  return axios({
    url: '/statistic/orderProfit/profit',
    method: 'post',
    data,
  });
};

/* 订单列表 */
export const listOrder = (data) => {
  return axios({
    url: '/statistic/order/listOrder',
    method: 'post',
    data,
  });
};

/* 订单利润列表 */
export const listOrderProfit = (data) => {
  return axios({
    url: '/statistic/orderProfit/listOrderProfit',
    method: 'post',
    data,
  });
};

/* 当日财务流水统计 */
export const getCurrentDayData = (data) => {
  return axios({
    url: '/statistic/finance/getCurrentDayData',
    method: 'post',
    data,
  });
};

/* 当日订单统计 */
export const getOrderCurrentDayData = (data) => {
  return axios({
    url: '/statistic/order/getCurrentDayData',
    method: 'post',
    data,
  });
};

/* 当日订单利润统计 */
export const getProfitCurrentDayData = (data) => {
  return axios({
    url: '/statistic/orderProfit/getCurrentDayData',
    method: 'post',
    data,
  });
};

/* 检查治疗项附加费用统计 */
export const getExamine = (data) => {
  return axios({
    url: '/statistic/examine/getExamine',
    method: 'post',
    data,
  });
};

/* 药品销售图表统计当天数据 */
export const realTimeChartStatistic = (data) => {
  return axios({
    url: '/statistic/drug/realTimeChartStatistic',
    method: 'post',
    data,
  });
};

/* 药品销售图表统计历史信息 */
export const chartStatistic = (data) => {
  return axios({
    url: '/statistic/drug/chartStatistic',
    method: 'post',
    data,
  });
};

// 药品统计
export const statisticDrugChart = (data) => {
  return axios({
    url: '/statistic/statistics/chart',
    method: 'post',
    data,
  });
};


// 销售明细图表
export const salesDetailChart = (data) => {
  return axios({
    url: '/statistic/detail/chart',
    method: 'post',
    data,
  });
};

// 销售明细图表
export const salesDetailDrug = (data) => {
  return axios({
    url: '/statistic/detail/drug',
    method: 'post',
    data,
  });
};

// 流水明细导出
export const financeExport = (params) => {
  const path = '/statistic/finance/export';
  fileExport(path, params);
};

// 订单信息导出
export const orderProfitExport = (params) => {
  const path = '/statistic/orderProfit/export';
  fileExport(path, params);
};

// 药品销售明细导出
export const salesDetailsExport = (params) => {
  const path = '/statistic/excel/drug/salesDetails';
  fileExport(path, params);
};

// 药品销售统计导出
export const salesStatisticExport = (params) => {
  const path = '/statistic/excel/drug/salesStatistic';
  fileExport(path, params);
};

export default {
  statsDrugs,
  listRealTimeStatisticDrug,
  getCurrentDayData,
  getDoctors,
  getStream,
  listDetailed,
  order,
  profit,
  listOrder,
  listOrderProfit,
  getOrderCurrentDayData,
  getProfitCurrentDayData,
  getExamine,
  realTimeChartStatistic,
  chartStatistic,
  statisticDrugChart,
  salesDetailChart,
  salesDetailDrug,
  financeExport,
  orderProfitExport,
  salesDetailsExport,
  salesStatisticExport,
};
